import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { AccountUserService } from '../service/account.service';
import { ReportsVisitsNames } from './models/reports-visits.enums';
import { TypeGroupIds } from '../modules/shared/constants/category-groupid.constants';
import { ReportsInventoryAPIMethods } from './models/reports-inventory.models';
import { FinanceFilterNS } from '../finance/models/finance-filter.model';
import { HttpService } from '../modules/shared/services/http.service';
@Injectable()
export class ReportService {

    appUrl = "";
    localAppUrl = "";
    appCore = "";
    reportUrl = "";
    configUrl = "";
    flatreportUrl = "";
    territoryUrl = "";
    financeURl = "";
    user;
    repoId;
    organizationId;
    fromdate;
    toDate;
    apiUrlLogin: string;
    questionare: string;
    whatsAppUrl: string;

    constructor(private http: HttpClient, private accountUserService: AccountUserService, private httpService: HttpService) {

        this.accountUserService.user.subscribe(x => this.user = x);
        this.reportUrl = environment.reportUrl;
        this.flatreportUrl = environment.flatReportUrl;
        this.configUrl = environment.configUrl;
        this.appCore = environment.baseUrl + "LionO360ApplicationLionOCoreAPI/LionO360/2.0/API/";
        this.apiUrlLogin = environment.appOrgUrl;
        this.questionare = environment.questionareUrl;
        this.territoryUrl = environment.territoryURL;
        this.financeURl = environment.financeURl;
        this.whatsAppUrl = environment.whatsAppUrl;
    }


    getPhoneModel() {
        return this.http.get<any>(this.apiUrlLogin + "Login/GetAllPhoneModel"
        )
            .toPromise()
            .then(res => res);
    }
    getQuestionareChannel() {
        return this.http.get<any>(this.questionare + "QuestionnaireChannel?OrganizationId=" + this.user.organizationId)
            .toPromise()
            .then(res => res);
    }
    getModules() {
        return this.http.get<any>(this.apiUrlLogin + 'UserPermission?UserId=' + this.user.userId)
            .toPromise()
            .then(res => res);
    }

    getTerritory() {
        return this.http.get<any>(this.territoryUrl + 'Territory/UserwiseTerritories/' + this.user.userId + "?isIncludeDeleted=false")
            .toPromise()
            .then(res => res);
    }
    getUsersHierachicalModules(organizationId: number, loggedinUserID: number) {
        return this.http.get<any>(`${this.apiUrlLogin}User/${loggedinUserID}/DownlineUsers`)
            .toPromise()
            .then(res => res);
    }


    getQuestionareTypes() {
        return this.http.get<any>(this.questionare + 'Type?groupId=' + TypeGroupIds.QuestionaireTypeOrganizationAPI)
            .toPromise()
            .then(res => res);
    }

    allProfitLossReport(reportType: string, fromDate, toDate) {
        return this.http.get<any>(`${this.financeURl}FinancialReport/ProfitLossReport?reportType=${reportType}&fromDate=${fromDate}&toDate=${toDate}`);
    }

    allCashFlowTreeNode(fromDate, toDate, dateFilterType: string, compareWithQueryString: string) {
        let url = `${this.financeURl}FinancialReport/CashFlowStatement/?fromDate=${fromDate}&toDate=${toDate}&dateFilterType=${dateFilterType}`;
        if (compareWithQueryString && compareWithQueryString.length > 0) {
            url += `&${compareWithQueryString}`;
        }

        return this.http.get<any>(url);
    }

    allProfitLossReportCustomize(reportType: string, fromDate, toDate, displayColumn: string) {
        return this.http.get<any>(`${this.financeURl}FinancialReport/ProfitLossReportCustomize/?reportType=${reportType}&fromDate=${fromDate}&toDate=${toDate}&displayColumn=${displayColumn}`);
    }
    allProfitLossReportCustomizeTreeNode(reportType: string, fromDate, toDate, displayColumn: string, compareWithQueryString: string) {
        let url = `${this.financeURl}FinancialReport/ProfitLossReportCustomizeTreeNode/?reportType=${reportType}&fromDate=${fromDate}&toDate=${toDate}&displayColumn=${displayColumn}`;
        if (compareWithQueryString && compareWithQueryString.length > 0) {
            url += `&${compareWithQueryString}`;
        }

        return this.http.get<any>(url);
    }
    allProfitLossReportCustomizeTreeNodeComparer(reportType: string, fromDate, toDate, fiscalYearStartDate, displayColumn: string, compareWithQueryString: string, filterWithQueryString: string) {
        let url = `${this.financeURl}FinancialReport/ProfitLossReportCustomizeTreeNodeComparer/?reportType=${reportType}&fromDate=${fromDate}&toDate=${toDate}&fiscalYearStartDate=${fiscalYearStartDate}&displayColumn=${displayColumn}`;
        if (compareWithQueryString && compareWithQueryString.length > 0) {
            url += `&${compareWithQueryString}`;
        }
        url += `&${filterWithQueryString}`;
        return this.http.get<any>(url);
    }
    allProfitLossReportCustomizeTreeNodeComparerPost(reportType: string, fromDate, toDate, displayColumn: string, compareWithQueryString: string, filterWithQueryString: string) {
        const data = { FromDate: fromDate, Todate: toDate };
        let url = `${this.financeURl}FinancialReport/ProfitLossReportCustomizeTreeNodeComparer/?reportType=${reportType}&displayColumn=${displayColumn}`;
        if (compareWithQueryString && compareWithQueryString.length > 0) {
            url += `&${compareWithQueryString}`;
        }
        url += `&${filterWithQueryString}`;
        return this.http.post<any>(url, data);
    }

    allProfitLossDetailReport(financialAccountId: number, fromDate, toDate) {
        return this.http.get<any>(`${this.financeURl}FinancialReport/ProfitAndLossTransactionDetail?reportType=profitandlossdetaill&financialAccountId=${financialAccountId}&fromDate=${fromDate}&toDate=${toDate}`);
    }


    AllLeadsReport(selectedChannelId: number, pageSize: number, pageNumber: number, fromdate, toDate, selectedWindow, selectedUser, selectedterritory, searchValue?: string) {
        selectedterritory = selectedterritory == null || selectedterritory == undefined ? { label: '', code: '0' } : selectedterritory;
        const userId = selectedUser ? selectedUser.id : 0;
        let url = "";

        if (searchValue == undefined) {
            if (selectedUser == null)
                url = this.reportUrl + 'LeadReport?reportType=' + selectedWindow + '&channelId=' + selectedChannelId + '&selectedUserId=' + userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code;
            else
                url = this.reportUrl + 'LeadReport?reportType=' + selectedWindow + '&channelId=' + selectedChannelId + '&selectedUserId=' + userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code;

        }
        else {
            if (selectedUser == null)
                url = this.reportUrl + 'LeadReport?reportType=' + selectedWindow + '&channelId=' + selectedChannelId + '&selectedUserId=' + userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize + '&SearchValue=' + searchValue + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code;
            else
                url = this.reportUrl + 'LeadReport?reportType=' + selectedWindow + '&channelId=' + selectedChannelId + '&selectedUserId=' + userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize + '&SearchValue=' + searchValue + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code;

        }

        return this.http.get<any>(url, { observe: 'response' })
            .toPromise()
            .then(res => ({
                contacts: res.body,
                headers: JSON.parse(res.headers.get('X-Pagination'))
            }));
    }

    LeadsReport(selectedChannelId: number, fromdate, toDate, selectedWindow) {

        let url = this.reportUrl + 'LeadReport?reportType=' + selectedWindow + '&channelId=' + selectedChannelId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&SortBy=CreatedDate&IsAscending=true';

        return this.http.get<any>(url, { observe: 'response' })
            .toPromise()
            .then(res => ({
                contacts: res.body,
                headers: JSON.parse(res.headers.get('X-Pagination'))
            }));
    }

    AllOpportunityReport(selectedChannelId: number, pageSize: number, pageNumber: number, fromdate, toDate, selectedWindow, selectedUser, selectedterritory, selectedStage, selectedDatePipelineFilter, searchValue?: string) {
        selectedterritory = selectedterritory == null || selectedterritory == undefined ? { label: '', code: '0' } : selectedterritory;
        selectedStage = selectedStage == null || selectedStage == undefined ? { name: 'All', id: '0' } : selectedStage;
        selectedDatePipelineFilter = selectedDatePipelineFilter == null || selectedDatePipelineFilter == undefined ? { name: 'All', id: '0' } : selectedDatePipelineFilter;
        const userId = selectedUser ? selectedUser.id : 0;
        const organizationId = selectedUser ? selectedUser.organizationId : 0;
        let url = "";

        if (searchValue == undefined) {
            if (selectedUser == null)
                url = this.reportUrl + 'OpportunityReport?reportType=' + selectedWindow + '&selectedUserId=' + userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code + '&stageId=' + selectedStage.id + '&pipelineId=' + selectedDatePipelineFilter.id;
            else
                url = this.reportUrl + 'OpportunityReport?reportType=' + selectedWindow + '&selectedUserId=' + userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code + '&stageId=' + selectedStage.id + '&pipelineId=' + selectedDatePipelineFilter.id;

        }
        else {
            if (selectedUser == null)
                url = this.reportUrl + 'OpportunityReport?reportType=' + selectedWindow + '&selectedUserId=' + userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize + '&SearchValue=' + searchValue + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code + '&stageId=' + selectedStage.id + '&pipelineId=' + selectedDatePipelineFilter.id;
            else
                url = this.reportUrl + 'OpportunityReport?reportType=' + selectedWindow + '&selectedUserId=' + userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize + '&SearchValue=' + searchValue + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code + '&stageId=' + selectedStage.id + '&pipelineId=' + selectedDatePipelineFilter.id;

        }

        return this.http.get<any>(url, { observe: 'response' })
            .toPromise()
            .then(res => ({
                contacts: res.body,
                headers: JSON.parse(res.headers.get('X-Pagination'))
            }));
    }

    OpportunityReports(fromdate, toDate, selectedWindow, accountchannelid = null, opportunitychannelid = null) {
        let url = this.reportUrl + 'OpportunityReport?reportType=' + selectedWindow + '&FromDate=' + fromdate + '&Todate=' + toDate;

        if (opportunitychannelid) {
            url = url + "&opportunitychannelid=" + opportunitychannelid;
        }

        if (accountchannelid) {
            url = url + "&accountchannelid=" + accountchannelid;
        }

        return this.http.get<any>(url, { observe: 'response' })
            .toPromise()
            .then(res => ({
                contacts: res.body,
                headers: JSON.parse(res.headers.get('X-Pagination'))
            }));
    }

    AllGoalsReport(selectedChannelId: number, pageSize: number, pageNumber: number, fromdate, toDate, selectedWindow, selectedUser, selectedterritory, selectedStage, selectedDatePipelineFilter, searchValue?: string) {
        selectedterritory = selectedterritory == null || selectedterritory == undefined ? { label: '', code: '0' } : selectedterritory;
        selectedStage = selectedStage == null || selectedStage == undefined ? { name: 'All', id: '0' } : selectedStage;
        selectedDatePipelineFilter = selectedDatePipelineFilter == null || selectedDatePipelineFilter == undefined ? { name: 'All', id: '0' } : selectedDatePipelineFilter;
        const userId = selectedUser ? selectedUser.id : 0;
        const organizationId = selectedUser ? selectedUser.organizationId : 0;
        let url = "";

        if (searchValue == undefined) {
            if (selectedUser == null)
                url = this.reportUrl + 'GoalsReport?reportType=' + selectedWindow + '&selectedUserId=' + userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code + '&stageId=' + selectedStage.id + '&pipelineId=' + selectedDatePipelineFilter.id;
            else
                url = this.reportUrl + 'GoalsReport?reportType=' + selectedWindow + '&selectedUserId=' + userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code + '&stageId=' + selectedStage.id + '&pipelineId=' + selectedDatePipelineFilter.id;

        }


        return this.http.get<any>(url, { observe: 'response' })
            .toPromise()
            .then(res => ({
                contacts: res.body,
                headers: JSON.parse(res.headers.get('X-Pagination'))
            }));
    }

    AllActivityReport(selectedChannelId: number, pageSize: number, pageNumber: number, fromdate, toDate, selectedWindow, selectedUser, selectedterritory, selectedModule, selectedDateActivityFilter, searchValue?: string) {
        selectedterritory = selectedterritory == null || selectedterritory == undefined ? { label: '', code: '0' } : selectedterritory;
        selectedModule = selectedModule == null || selectedModule == undefined ? { name: '', id: '0' } : selectedModule;
        selectedDateActivityFilter = selectedDateActivityFilter == null || selectedDateActivityFilter == undefined ? { name: 'All', id: '0' } : selectedDateActivityFilter;
        const userId = selectedUser ? selectedUser.id : 0;
        let url = "";

        let reportUrlOptimized = this.reportUrl;
        if (selectedWindow === 'activityAnalyticReportSummarydasboard' || selectedWindow === 'outboundCallRequiredByTerritory' || selectedWindow === 'outboundCallDashboardMadeByRep' || selectedWindow === 'outboundCallDashboardMadeByTerritory' || selectedWindow === 'outboundCallDashboardMadeByState') {
            reportUrlOptimized = this.reportUrl + 'ActivityReport';
            if (searchValue == undefined) {
                if (selectedUser == null)
                    url = reportUrlOptimized + '?reportType=' + selectedWindow + '&channelId=' + selectedChannelId + '&selectedUserId=' + userId + '&loggedInUserId=' + this.user.userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code + '&moduleId=' + selectedModule.id + '&activityName=' + selectedDateActivityFilter.name;
                else
                    url = reportUrlOptimized + '?reportType=' + selectedWindow + '&channelId=' + selectedChannelId + '&selectedUserId=' + userId + '&loggedInUserId=' + this.user.userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code + '&moduleId=' + selectedModule.id + '&activityName=' + selectedDateActivityFilter.name;

            }
            else {
                if (selectedUser == null)
                    url = reportUrlOptimized + '?reportType=' + selectedWindow + '&channelId=' + selectedChannelId + '&selectedUserId=' + userId + '&loggedInUserId=' + this.user.userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize + '&SearchValue=' + searchValue + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code + '&moduleId=' + selectedModule.id + '&activityName=' + selectedDateActivityFilter.name;
                else
                    url = reportUrlOptimized + '?reportType=' + selectedWindow + '&channelId=' + selectedChannelId + '&selectedUserId=' + userId + '&loggedInUserId=' + this.user.userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize + '&SearchValue=' + searchValue + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code + '&moduleId=' + selectedModule.id + '&activityName=' + selectedDateActivityFilter.name;

            }
        }
        else {
            if (selectedWindow === 'activityAnalyticReportSummary' || selectedWindow === 'activityAnalyticReportDetail' || selectedWindow === 'outboundCallReport' || selectedWindow === 'outboundCallRequired' || selectedWindow === 'inboundCallReport' || selectedWindow === 'top10ActivityUser') {
                reportUrlOptimized = this.reportUrl + 'ActivityReport';
            }
            else { reportUrlOptimized = this.reportUrl + 'ActivityReport'; }
            if (searchValue == undefined) {
                if (selectedUser == null)
                    url = reportUrlOptimized + '?reportType=' + selectedWindow + '&channelId=' + selectedChannelId + '&selectedUserId=' + userId + '&loggedInUserId=' + this.user.userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code + '&moduleId=' + selectedModule.id + '&activityName=' + selectedDateActivityFilter.name;
                else
                    url = reportUrlOptimized + '?reportType=' + selectedWindow + '&channelId=' + selectedChannelId + '&selectedUserId=' + userId + '&loggedInUserId=' + this.user.userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code + '&moduleId=' + selectedModule.id + '&activityName=' + selectedDateActivityFilter.name;

            }
            else {
                if (selectedUser == null)
                    url = reportUrlOptimized + '?reportType=' + selectedWindow + '&channelId=' + selectedChannelId + '&selectedUserId=' + userId + '&loggedInUserId=' + this.user.userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize + '&SearchValue=' + searchValue + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code + '&moduleId=' + selectedModule.id + '&activityName=' + selectedDateActivityFilter.name;
                else
                    url = reportUrlOptimized + '?reportType=' + selectedWindow + '&channelId=' + selectedChannelId + '&selectedUserId=' + userId + '&loggedInUserId=' + this.user.userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize + '&SearchValue=' + searchValue + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code + '&moduleId=' + selectedModule.id + '&activityName=' + selectedDateActivityFilter.name;

            }
        }


        return this.http.get<any>(url, { observe: 'response' })
            .toPromise()
            .then(res => ({
                contacts: res.body,
                headers: JSON.parse(res.headers.get('X-Pagination'))
            }));
    }

    AllAccountReport(selectedChannelId: number, pageSize: number, pageNumber: number, fromdate, toDate, selectedWindow, selectedUser, selectedterritory, selectedStage, searchValue?: string) {
        selectedterritory = selectedterritory == null || selectedterritory == undefined ? { label: '', code: '0' } : selectedterritory;
        selectedStage = selectedStage == null || selectedStage == undefined ? { name: '', id: '0' } : selectedStage;
        const userId = selectedUser ? selectedUser.id : 0;
        let url = "";
        let reportUrlOptimized = this.reportUrl;
        if (selectedWindow === 'accountbyaccountType_dashboard') {
            reportUrlOptimized = this.reportUrl + 'AccountReport';

            if (searchValue == undefined) {

                if (selectedUser == null)
                    url = reportUrlOptimized + '?reportType=' + selectedWindow + '&channelId=' + selectedChannelId + '&selectedUserId=' + userId + '&loggedInUserId=' + this.user.userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code + '&stageId=' + selectedStage.id;
                else
                    url = reportUrlOptimized + '?reportType=' + selectedWindow + '&channelId=' + selectedChannelId + '&selectedUserId=' + userId + '&loggedInUserId=' + this.user.userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code + '&stageId=' + selectedStage.id;

            }
            else {
                if (selectedUser == null)
                    url = reportUrlOptimized + '?reportType=' + selectedWindow + '&channelId=' + selectedChannelId + '&selectedUserId=' + userId + '&loggedInUserId=' + this.user.userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize + '&SearchValue=' + searchValue + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code + '&stageId=' + selectedStage.id;
                else
                    url = reportUrlOptimized + '?reportType=' + selectedWindow + '&channelId=' + selectedChannelId + '&selectedUserId=' + userId + '&loggedInUserId=' + this.user.userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize + '&SearchValue=' + searchValue + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code + '&stageId=' + selectedStage.id;

            }

        }
        else {
            if (selectedWindow === 'accountsActivityReport' || selectedWindow === 'accountsNoActivityReport') {
                reportUrlOptimized = this.reportUrl + 'AccountReport';

            }
            else { reportUrlOptimized = this.reportUrl + 'AccountReport'; }
            if (searchValue == undefined) {

                if (selectedUser == null)
                    url = reportUrlOptimized + '?reportType=' + selectedWindow + '&channelId=' + selectedChannelId + '&selectedUserId=' + userId + '&loggedInUserId=' + this.user.userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code + '&stageId=' + selectedStage.id;
                else
                    url = reportUrlOptimized + '?reportType=' + selectedWindow + '&channelId=' + selectedChannelId + '&selectedUserId=' + userId + '&loggedInUserId=' + this.user.userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code + '&stageId=' + selectedStage.id;

            }
            else {
                if (selectedUser == null)
                    url = reportUrlOptimized + '?reportType=' + selectedWindow + '&channelId=' + selectedChannelId + '&selectedUserId=' + userId + '&loggedInUserId=' + this.user.userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize + '&SearchValue=' + searchValue + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code + '&stageId=' + selectedStage.id;
                else
                    url = reportUrlOptimized + '?reportType=' + selectedWindow + '&channelId=' + selectedChannelId + '&selectedUserId=' + userId + '&loggedInUserId=' + this.user.userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize + '&SearchValue=' + searchValue + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code + '&stageId=' + selectedStage.id;

            }
        }
        return this.http.get<any>(url, { observe: 'response' })
            .toPromise()
            .then(res => ({
                contacts: res.body,
                headers: JSON.parse(res.headers.get('X-Pagination'))
            }));
    }
    AllCasesReport(selectedChannelId: number, pageSize: number, pageNumber: number, fromdate, toDate, selectedWindow, selectedUser, selectedterritory, selectedcategoryId, selectedModule, selectedPriority, selectedAccount, selectedLead, selectedSource, selectedCasesChannel, searchValue?: string) {
        selectedterritory = selectedterritory == null || selectedterritory == undefined ? { label: '', code: '0' } : selectedterritory;
        selectedcategoryId = selectedcategoryId == null || selectedcategoryId == undefined ? { name: '', id: '0' } : selectedcategoryId;
        selectedModule = selectedModule == null || selectedModule == undefined ? { name: '', id: '0' } : selectedModule;
        selectedPriority = selectedPriority == null || selectedPriority == undefined ? { name: '', id: '0' } : selectedPriority;
        selectedAccount = selectedAccount == null || selectedAccount == undefined ? { businessName: '', id: '0' } : selectedAccount;
        selectedLead = selectedLead == null || selectedLead == undefined ? { businessName: '', id: '0' } : selectedLead;
        selectedSource = selectedSource == null || selectedSource == undefined ? { name: '', id: '0' } : selectedSource;
        selectedCasesChannel = selectedCasesChannel == null || selectedCasesChannel == undefined ? { name: '', id: '0' } : selectedCasesChannel;

        const userId = selectedUser ? selectedUser.id : 0;
        const organizationId = selectedUser ? selectedUser.organizationId : 0;
        let url = "";

        if (searchValue == undefined) {
            if (selectedUser == null)
                url = this.reportUrl + 'CasesReport?reportType=' + selectedWindow + '&channelId=' + selectedCasesChannel.id + '&selectedUserId=' + userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code + '&stageId=' + selectedcategoryId.id + '&moduleId=' + selectedModule.id + '&priorityId=' + selectedPriority.id + '&accountId=' + selectedAccount.id + '&leadId=' + selectedLead.id + '&sourceId=' + selectedSource.id;
            else
                url = this.reportUrl + 'CasesReport?reportType=' + selectedWindow + '&channelId=' + selectedCasesChannel.id + '&selectedUserId=' + userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code + '&stageId=' + selectedcategoryId.id + '&moduleId=' + selectedModule.id + '&priorityId=' + selectedPriority.id + '&accountId=' + selectedAccount.id + '&leadId=' + selectedLead.id + '&sourceId=' + selectedSource.id;

        }
        else {
            if (selectedUser == null)
                url = this.reportUrl + 'CasesReport?reportType=' + selectedWindow + '&channelId=' + selectedCasesChannel.id + '&selectedUserId=' + userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize + '&SearchValue=' + searchValue + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code + '&stageId=' + selectedcategoryId.id + '&moduleId=' + selectedModule.id + '&priorityId=' + selectedPriority.id + '&accountId=' + selectedAccount.id + '&leadId=' + selectedLead.id + '&sourceId=' + selectedSource.id;
            else
                url = this.reportUrl + 'CasesReport?reportType=' + selectedWindow + '&channelId=' + selectedCasesChannel.id + '&selectedUserId=' + userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize + '&SearchValue=' + searchValue + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code + '&stageId=' + selectedcategoryId.id + '&moduleId=' + selectedModule.id + '&priorityId=' + selectedPriority.id + '&accountId=' + selectedAccount.id + '&leadId=' + selectedLead.id + '&sourceId=' + selectedSource.id;

        }

        return this.http.get<any>(url, { observe: 'response' })
            .toPromise()
            .then(res => ({
                contacts: res.body,
                headers: JSON.parse(res.headers.get('X-Pagination'))
            }));
    }
    AllLoginReport(selectedChannelId: number, pageSize: number, pageNumber: number, fromdate, toDate, selectedWindow, selectedUser, selectedterritory, selectedcategoryId, selectedModule, selectedPriority, selectedAccount, selectedLead, selectedPhoneModel, searchValue?: string) {
        selectedterritory = selectedterritory == null || selectedterritory == undefined ? { label: '', code: '0' } : selectedterritory;
        selectedcategoryId = selectedcategoryId == null || selectedcategoryId == undefined ? { name: '', id: '0' } : selectedcategoryId;
        selectedModule = selectedModule == null || selectedModule == undefined ? { name: '', id: '0' } : selectedModule;
        selectedPriority = selectedPriority == null || selectedPriority == undefined ? { name: '', id: '0' } : selectedPriority;
        selectedAccount = selectedAccount == null || selectedAccount == undefined ? { businessName: '', id: '0' } : selectedAccount;
        selectedLead = selectedLead == null || selectedLead == undefined ? { businessName: '', id: '0' } : selectedLead;
        selectedPhoneModel = selectedPhoneModel == null || selectedPhoneModel == undefined ? { name: '', id: '0' } : selectedPhoneModel;

        const userId = selectedUser ? selectedUser.id : 0;
        let url = ""
        let reportUrlOptimized = this.reportUrl + 'MobileAccessReport'

        if (searchValue == undefined) {
            if (selectedUser == null)
                url = reportUrlOptimized + '?reportType=' + selectedWindow + '&channelId=' + selectedChannelId + '&selectedUserId=' + userId + '&loggedInUserId=' + this.user.userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code + '&stageId=' + selectedcategoryId.id + '&moduleId=' + selectedModule.id + '&priorityId=' + selectedPriority.id + '&accountId=' + selectedAccount.id + '&leadId=' + selectedLead.id + '&phoneModelName=' + selectedPhoneModel.name;
            else
                url = reportUrlOptimized + '?reportType=' + selectedWindow + '&channelId=' + selectedChannelId + '&selectedUserId=' + userId + '&loggedInUserId=' + this.user.userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code + '&stageId=' + selectedcategoryId.id + '&moduleId=' + selectedModule.id + '&priorityId=' + selectedPriority.id + '&accountId=' + selectedAccount.id + '&leadId=' + selectedLead.id + '&phoneModelName=' + selectedPhoneModel.name;

        }
        else {
            if (selectedUser == null)
                url = reportUrlOptimized + '?reportType=' + selectedWindow + '&channelId=' + selectedChannelId + '&selectedUserId=' + userId + '&loggedInUserId=' + this.user.userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&SearchValue=' + searchValue + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code + '&stageId=' + selectedcategoryId.id + '&moduleId=' + selectedModule.id + '&priorityId=' + selectedPriority.id + '&accountId=' + selectedAccount.id + '&leadId=' + selectedLead.id + '&phoneModelName=' + selectedPhoneModel.name;
            else
                url = reportUrlOptimized + '?reportType=' + selectedWindow + '&channelId=' + selectedChannelId + '&selectedUserId=' + userId + '&loggedInUserId=' + this.user.userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&SearchValue=' + searchValue + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code + '&stageId=' + selectedcategoryId.id + '&moduleId=' + selectedModule.id + '&priorityId=' + selectedPriority.id + '&accountId=' + selectedAccount.id + '&leadId=' + selectedLead.id + '&phoneModelName=' + selectedPhoneModel.name;

        }

        return this.http.get<any>(url, { observe: 'response' })
            .toPromise()
            .then(res => ({
                contacts: res.body,
                headers: JSON.parse(res.headers.get('X-Pagination'))
            }));
    }
    AllFieldVisitReport(selectedChannelId: number, pageSize: number, pageNumber: number, fromdate, toDate, selectedWindow, selectedUser, selectedterritory, selectedcategoryId, selectedModule, searchValue?: string) {
        selectedterritory = selectedterritory == null || selectedterritory == undefined ? { label: '', code: '0' } : selectedterritory;
        let territoryIds;

        selectedcategoryId = selectedcategoryId == null || selectedcategoryId == undefined ? { name: '', id: '0' } : selectedcategoryId;
        let userId = selectedUser ? selectedUser.id : 0;
        const organizationId = selectedUser ? selectedUser.organizationId : 0;
        selectedModule = selectedModule == null || selectedModule == undefined ? { name: '', id: '0' } : selectedModule;
        let url = "";

        if ([ReportsVisitsNames.getterritorywiseaccountvisithistoryofrep, ReportsVisitsNames.getterritorywiseleadvisithistoryofrep, ReportsVisitsNames.getterritorywiseaccountvisithistory, ReportsVisitsNames.getterritorywiseleadvisithistory].includes(selectedWindow)) {
            territoryIds = territoryIds?.length ? territoryIds : "";
            selectedterritory = 0;
            userId = selectedUser;
        } else {
            selectedterritory = selectedterritory.code;
            territoryIds = "";
        }

        if (ReportsVisitsNames.getterritorywiseaccountvisithistory == selectedWindow) {
            selectedWindow = 'getaccountwisevisitstatus';
        } else if (ReportsVisitsNames.getterritorywiseleadvisithistory == selectedWindow) {
            selectedWindow = 'getleadwisevisitstatus';
        }

        if (selectedWindow.toLowerCase() == 'storesvisitedbyrepdashboard'.toLowerCase() || selectedWindow.toLowerCase() == 'storevisitsrequiredbystatedashboard'.toLowerCase() || selectedWindow.toLowerCase() == 'StoreVisitsRequiredByRepDashboard'.toLowerCase() || selectedWindow.toLowerCase() == 'StoresVisitedRequiredByTerritoryDashboard'.toLowerCase()) {
            let reportUrlOptimized = this.reportUrl + 'FieldVisitReport';
            if (searchValue == undefined) {
                if (selectedUser == null)
                    url = reportUrlOptimized + '?reportType=' + selectedWindow + '&channelId=' + selectedChannelId + '&selectedUserId=' +
                        userId + '&loggedInUserId=' + this.user.userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate='
                        + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize +
                        '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory + '&territoryIds=' + territoryIds +
                        '&stageId=' + selectedcategoryId.id + '&moduleId=' + selectedModule.id;
                else
                    url = reportUrlOptimized + '?reportType=' + selectedWindow + '&channelId=' + selectedChannelId + '&selectedUserId='
                        + userId + '&loggedInUserId=' + this.user.userId + '&selectedOrganizationId=' + this.user.organizationId +
                        '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize +
                        '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory + '&territoryIds=' + territoryIds
                        + '&stageId=' + selectedcategoryId.id + '&moduleId=' + selectedModule.id;
            }
            else {
                if (selectedUser == null)
                    url = reportUrlOptimized + '?reportType=' + selectedWindow + '&channelId=' + selectedChannelId + '&selectedUserId='
                        + userId + '&loggedInUserId=' + this.user.userId + '&selectedOrganizationId=' + this.user.organizationId +
                        '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize +
                        '&SearchValue=' + searchValue + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory +
                        '&territoryIds=' + territoryIds + '&stageId=' + selectedcategoryId.id + '&moduleId=' + selectedModule.id;
                else
                    url = reportUrlOptimized + '?reportType=' + selectedWindow + '&channelId=' + selectedChannelId +
                        '&selectedUserId=' + userId + '&loggedInUserId=' + this.user.userId + '&selectedOrganizationId=' +
                        this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber +
                        '&PageSize=' + pageSize + '&SearchValue=' + searchValue + '&SortBy=CreatedDate&IsAscending=true&territoryId='
                        + selectedterritory + '&territoryIds=' + territoryIds + '&stageId=' + selectedcategoryId.id + '&moduleId=' + selectedModule.id;
            }
        }
        else {
            let reportUrlOptimized = this.reportUrl;
            if (selectedWindow === 'visitbyrepsummary' || selectedWindow === 'visitbytypesummary' || selectedWindow === 'visitbyterritorysummary' || selectedWindow === 'visitbyrepdetail' || selectedWindow === 'visitbyterritorydetail' || selectedWindow === 'visitbytypedetail' || selectedWindow === 'storevisited' || selectedWindow === 'storevisitsrequire') {
                reportUrlOptimized = this.reportUrl + 'FieldVisitReport';
            }
            else { reportUrlOptimized = this.reportUrl + 'FieldVisitReport'; }
            if (searchValue == undefined) {
                if (selectedUser == null) {
                    url = reportUrlOptimized + '?reportType=' + selectedWindow + '&channelId=' + selectedChannelId + '&selectedUserId='
                        + userId + '&loggedInUserId=' + this.user.userId + '&selectedOrganizationId=' + this.user.organizationId +
                        '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize +
                        '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory + '&territoryIds=' + territoryIds + '&territoryName=' +
                        selectedterritory.label + '&stageId=' + selectedcategoryId.id + '&moduleId=' + selectedModule.id;
                }
                else
                    url = reportUrlOptimized + '?reportType=' + selectedWindow + '&channelId=' + selectedChannelId + '&selectedUserId='
                        + userId + '&loggedInUserId=' + this.user.userId + '&selectedOrganizationId=' + this.user.organizationId +
                        '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize +
                        '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory + '&territoryIds=' + territoryIds + '&territoryName=' +
                        selectedterritory.label + '&stageId=' + selectedcategoryId.id + '&moduleId=' + selectedModule.id;

            }
            else {
                if (selectedUser == null)
                    url = reportUrlOptimized + '?reportType=' + selectedWindow + '&channelId=' + selectedChannelId + '&selectedUserId='
                        + userId + '&loggedInUserId=' + this.user.userId + '&selectedOrganizationId=' + this.user.organizationId +
                        '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize +
                        '&SearchValue=' + searchValue + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory + '&territoryIds=' + territoryIds +
                        '&territoryName=' + selectedterritory.label + '&stageId=' + selectedcategoryId.id + '&moduleId=' + selectedModule.id;
                else
                    url = reportUrlOptimized + '?reportType=' + selectedWindow + '&channelId=' + selectedChannelId + '&selectedUserId='
                        + userId + '&loggedInUserId=' + this.user.userId + '&selectedOrganizationId=' + this.user.organizationId +
                        '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize +
                        '&SearchValue=' + searchValue + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory +
                        '&territoryIds=' + territoryIds + '&territoryName=' + selectedterritory.label + '&stageId=' + selectedcategoryId.id +
                        '&moduleId=' + selectedModule.id;

            }
        }

        return this.http.get<any>(url, { observe: 'response' })
            .toPromise()
            .then(res => ({
                contacts: res.body,
                headers: JSON.parse(res.headers.get('X-Pagination'))
            }));
    }

    AllStoreVisitHistoryReport(selectedChannelId: number, pageSize: number, pageNumber: number, fromdate, toDate, selectedWindow, selectedUser, selectedterritory, selectedcategoryId, selectedModule, visitedStatus, repStatus, selectedQuestionareType, selectedQuestionareChannel, searchValue?: string) {
        selectedterritory = selectedterritory == null || selectedterritory == undefined ? { label: '', code: '0' } : selectedterritory;
        selectedcategoryId = selectedcategoryId == null || selectedcategoryId == undefined ? { name: '', id: '0' } : selectedcategoryId;

        selectedQuestionareType = selectedQuestionareType == null || selectedQuestionareType == undefined ? { name: '', id: '0' } : selectedQuestionareType;
        selectedQuestionareChannel = selectedQuestionareChannel == null || selectedQuestionareChannel == undefined ? { name: '', id: '0' } : selectedQuestionareChannel;
        const userId = selectedUser ? selectedUser.id : 0;
        const organizationId = selectedUser ? selectedUser.organizationId : 0;
        selectedModule = selectedModule == null || selectedModule == undefined ? { name: '', id: '0' } : selectedModule;

        let url = "";


        let reportUrlOptimized;

        reportUrlOptimized = this.reportUrl + 'FieldVisitReport';

        if (searchValue == undefined) {
            if (selectedUser == null)
                url = reportUrlOptimized + '?reportType=' + selectedWindow + '&questionnaireChannelId=' + 1 + '&selectedUserId=' + userId + '&loggedInUserId=' + this.user.userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code + '&VisitTypeId=' + selectedcategoryId.id + '&moduleId=' + selectedModule.id + '&VisitType=' + visitedStatus + '&RepStatus=' + repStatus + '&ActivityName=' + selectedQuestionareType.name;
            else
                url = reportUrlOptimized + '?reportType=' + selectedWindow + '&questionnaireChannelId=' + 1 + '&selectedUserId=' + userId + '&loggedInUserId=' + this.user.userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code + '&VisitTypeId=' + selectedcategoryId.id + '&moduleId=' + selectedModule.id + '&VisitType=' + visitedStatus + '&RepStatus=' + repStatus + '&ActivityName=' + selectedQuestionareType.name;
        }


        return this.http.get<any>(url, { observe: 'response' })
            .toPromise()
            .then(res => ({
                contacts: res.body,
                headers: JSON.parse(res.headers.get('X-Pagination'))
            }));
    }

    AllQuestionareReport(selectedChannelId: number, pageSize: number, pageNumber: number, fromdate, toDate, selectedWindow, selectedUser, selectedterritory, selectedcategoryId, selectedModule, selectedDateAccountName, selectedQuestionarechannel, searchValue?: string) {
        selectedterritory = selectedterritory == null || selectedterritory == undefined ? { label: '', code: '0' } : selectedterritory;
        selectedcategoryId = selectedcategoryId == null || selectedcategoryId == undefined ? { name: '', id: '0' } : selectedcategoryId;
        const userId = selectedUser ? selectedUser.id : 0;
        const organizationId = selectedUser ? selectedUser.organizationId : 0;
        selectedModule = selectedModule == null || selectedModule == undefined ? { name: '', id: '0' } : selectedModule;
        selectedQuestionarechannel = selectedQuestionarechannel == null || selectedQuestionarechannel == undefined ? { name: '', id: '0' } : selectedQuestionarechannel;
        selectedDateAccountName = selectedDateAccountName == null || selectedDateAccountName == undefined ? { businessName: '', id: 0 } : selectedDateAccountName;
        let url = "";

        let reportUrlOptimized = this.reportUrl;
        if (selectedWindow === 'questionareDetail') {
            reportUrlOptimized = this.reportUrl + 'questionareReport';
        }
        else { reportUrlOptimized = this.reportUrl + 'questionareReport'; }


        if (searchValue == undefined) {
            if (selectedUser == null)
                url = reportUrlOptimized + '?reportType=' + selectedWindow + '&channelId=' + selectedChannelId + '&selectedUserId=' + userId + '&loggedInUserId=' + this.user.userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code + '&territoryName=' + selectedterritory.label + '&moduleId=' + selectedModule.id + '&timeZoneOffset=20&moduleName=' + selectedModule.name + '&questionnaireChannelId=' + selectedQuestionarechannel.id + '&accountName=' + selectedDateAccountName.businessName;
            else
                url = reportUrlOptimized + '?reportType=' + selectedWindow + '&channelId=' + selectedChannelId + '&selectedUserId=' + userId + '&loggedInUserId=' + this.user.userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code + '&territoryName=' + selectedterritory.label + '&moduleId=' + selectedModule.id + '&timeZoneOffset=20&moduleName=' + selectedModule.name + '&questionnaireChannelId=' + selectedQuestionarechannel.id + '&accountName=' + selectedDateAccountName.businessName;
        }
        else {
            if (selectedUser == null)
                url = reportUrlOptimized + '?reportType=' + selectedWindow + '&channelId=' + selectedChannelId + '&selectedUserId=' + userId + '&loggedInUserId=' + this.user.userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize + '&SearchValue=' + searchValue + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code + '&moduleId=' + selectedModule.id + '&timeZoneOffset=20&moduleName=' + selectedModule.name + '&questionnaireChannelId=' + selectedQuestionarechannel.id + '&accountName=' + selectedDateAccountName.businessName;
            else
                url = reportUrlOptimized + '?reportType=' + selectedWindow + '&channelId=' + selectedChannelId + '&selectedUserId=' + userId + '&loggedInUserId=' + this.user.userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize + '&SearchValue=' + searchValue + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code + '&moduleId=' + selectedModule.id + '&timeZoneOffset=20&moduleName=' + selectedModule.name + '&questionnaireChannelId=' + selectedQuestionarechannel.id + '&accountName=' + selectedDateAccountName.businessName;
        }

        return this.http.get<any>(url, { observe: 'response' })
            .toPromise()
            .then(res => ({
                contacts: res.body,
                headers: JSON.parse(res.headers.get('X-Pagination'))
            }));
    }

    AllQuestionareChartReport(selectedChannelId: number, fromdate?, toDate?) {

        let url = this.reportUrl + 'SurveyReport/?id=' + selectedChannelId;

        if (fromdate && toDate) {
            url = url + '&FromDate=' + fromdate + '&Todate=' + toDate;
        }

        return this.http.get<any>(url, { observe: 'response' })
            .toPromise()
            .then(res => ({
                contacts: res.body,
                headers: JSON.parse(res.headers.get('X-Pagination'))
            }));
    }


    PDFExportReport(selectedChannelId: number, pageSize: number, pageNumber: number, fromdate, toDate, selectedWindow, selectedUser, selectedOrganizationId, selectedterritory) {
        const userId = selectedUser ? selectedUser.id : 0;
        const organizationId = selectedUser ? selectedUser.organizationId : 0;
        let url = "";

        if (selectedUser == null)
            url = this.reportUrl + 'LeadReport?reportType=' + selectedWindow + '&selectedUserId=' + userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code;
        else
            url = this.reportUrl + 'LeadReport?reportType=' + selectedWindow + '&selectedUserId=' + userId + '&selectedOrganizationId=' + this.user.organizationId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize + '&SortBy=CreatedDate&IsAscending=true&territoryId=' + selectedterritory.code;


        return this.http.get<any>(url, { observe: 'response' })
            .toPromise()
            .then(res => ({
                contacts: res.body,
                headers: JSON.parse(res.headers.get('X-Pagination'))
            }));
    }


    InventoryInvoice(reportType: string, fromdate, toDate) {
        let url = "";
        url = this.reportUrl + 'InventoryReport/InventoryInvoice?reportType=' + reportType + '&FromDate=' + fromdate + '&Todate=' + toDate;
        return this.http.get<any>(url, { observe: 'response' })
            .toPromise()
            .then(res => ({
                reports: res.body,
                headers: JSON.parse(res.headers.get('X-Pagination'))
            }));
    }
    InventoryCustomers(reportType: string, fromdate, toDate) {
        let url = "";
        url = this.reportUrl + 'InventoryReport/InventoryCustomers?reportType=' + reportType + '&FromDate=' + fromdate + '&Todate=' + toDate;
        return this.http.get<any>(url, { observe: 'response' })
            .toPromise()
            .then(res => ({
                reports: res.body,
                headers: JSON.parse(res.headers.get('X-Pagination'))
            }));
    }
    InventorySalesOrder(reportType: string, fromdate, toDate) {
        let url = "";
        url = this.reportUrl + 'InventoryReport/InventorySalesOrder?reportType=' + reportType + '&FromDate=' + fromdate + '&Todate=' + toDate;
        return this.http.get<any>(url, { observe: 'response' })
            .toPromise()
            .then(res => ({
                reports: res.body,
                headers: JSON.parse(res.headers.get('X-Pagination'))
            }));
    }
    allInventoryReports(reportType: string, channelId: number, fromdate: any, toDate: any, apiMethodName: string, filtertype?: string) {
        let url = "";
        if (apiMethodName == ReportsInventoryAPIMethods.InventoryInvoice
            || apiMethodName == ReportsInventoryAPIMethods.InventoryCustomers
            || apiMethodName == ReportsInventoryAPIMethods.InventoryVendor) {
            let data = { FromDate: fromdate, Todate: toDate };
            if (filtertype) {
                url = this.reportUrl + 'InventoryReport/' + apiMethodName + '?reportType=' + reportType + '&channelId=' + channelId + '&datefiltertype=' + filtertype;
            }
            else {
                url = this.reportUrl + 'InventoryReport/' + apiMethodName + '?reportType=' + reportType + '&channelId=' + channelId;
            }
            return this.http.post<any>(url, data, { observe: 'response' },)
                .toPromise()
                .then(res => ({
                    reports: res.body,
                    headers: JSON.parse(res.headers.get('X-Pagination'))
                }));
        }
        if (filtertype) {
            url = this.reportUrl + 'InventoryReport/' + apiMethodName + '?reportType=' + reportType + '&channelId=' + channelId + '&FromDate=' + fromdate + '&Todate=' + toDate + '&datefiltertype=' + filtertype;
        } else {
            url = this.reportUrl + 'InventoryReport/' + apiMethodName + '?reportType=' + reportType + '&channelId=' + channelId + '&FromDate=' + fromdate + '&Todate=' + toDate;
        }
        return this.http.get<any>(url, { observe: 'response' })
            .toPromise()
            .then(res => ({
                reports: res.body,
                headers: JSON.parse(res.headers.get('X-Pagination'))
            }));
    }

    allInventoryReportsNew(data: FinanceFilterNS.InventoryAccountsFilterRequestModel) {
        let url = "";
        const baseUrl = environment.reportUrl + "InventoryReport/";

        if (
            data.apiMethodName === ReportsInventoryAPIMethods.InventoryInvoice ||
            data.apiMethodName === ReportsInventoryAPIMethods.InventoryCustomers ||
            data.apiMethodName === ReportsInventoryAPIMethods.InventoryVendor
        ) {
            if (data.dateFilterType) {
                url = `${baseUrl}${data.apiMethodName}?datefiltertype=${data.dateFilterType}`;
            } else {
                url = `${baseUrl}${data.apiMethodName}`;
            }

            return this.http
                .post<any>(url, data, { observe: "response" })
                .toPromise()
                .then((res) => ({
                    inventory: res.body,
                    headers: JSON.parse(res.headers.get("X-Pagination"))
                }));
        } else {
            if (data.dateFilterType) {
                url = `${baseUrl}${data.apiMethodName}?datefiltertype=${data.dateFilterType}`;
            } else {
                url = `${baseUrl}${data.apiMethodName}`;
            }

            return this.http
                .get<any>(url, { observe: "response" })
                .toPromise()
                .then((res) => ({
                    inventory: res.body,
                    headers: JSON.parse(res.headers.get("X-Pagination"))
                }));
        }
    }

    getInventoryValuationReports(reportType: string, channelId: number, warehouseId: number, showInActive: boolean, fromdate: any, toDate: any, apiMethodName: string) {
        let url = "";
        url = this.reportUrl + 'InventoryReport/' + apiMethodName + '?reportType=' + reportType + '&channelId=' + channelId + '&warehouseId=' + warehouseId + '&showInActive=' + showInActive + '&FromDate=' + fromdate + '&Todate=' + toDate;
        return this.http.get<any>(url, { observe: 'response' })
            .toPromise()
            .then(res => ({
                reports: res.body,
                headers: JSON.parse(res.headers.get('X-Pagination'))
            }));
    }
    allAgingReorts(fromdate: any, toDate: any, filter?: string) {

        let url = "";
        url = this.reportUrl + 'InventoryReport/InventoryAgingReport?datefiltertype=' + filter + '&FromDate=' + fromdate + '&Todate=' + toDate;
        return this.http.get<any>(url, { observe: 'response' })
            .toPromise()
            .then(res => ({
                reports: res.body,
                headers: JSON.parse(res.headers.get('X-Pagination'))
            }));
    }

    allAgingFilterReorts(data) {
        let url = "";
        url = this.reportUrl + 'InventoryReport/InventoryAgingReport';
        return this.http.post<any>(url, data)
            .toPromise()
            .then(res => res);
    }

    allInventoryReportsDetails(reportType: string, channelId: number, idPart: string, fromdate: any, toDate: any, apiMethodName: string, filtertype?: string) {
        let url = "";
        if (apiMethodName == ReportsInventoryAPIMethods.AccountsReceivableDetail
            || apiMethodName == ReportsInventoryAPIMethods.AccountsPayableDetail) {
            let data = { FromDate: fromdate, Todate: toDate };
            if (filtertype) {
                url = this.reportUrl + 'InventoryReport/' + apiMethodName + '?reportType=' + reportType + '&channelId=' + channelId + idPart + '&datefiltertype=' + filtertype;
            } else {
                url = this.reportUrl + 'InventoryReport/' + apiMethodName + '?reportType=' + reportType + '&channelId=' + channelId + idPart;
            }
            return this.http.post<any>(url, data, { observe: 'response' },)
                .toPromise()
                .then(res => ({
                    reports: res.body,
                    headers: JSON.parse(res.headers.get('X-Pagination'))
                }));
        }
        if (filtertype) {
            url = this.reportUrl + 'InventoryReport/' + apiMethodName + '?reportType=' + reportType + '&channelId=' + channelId + idPart + '&FromDate=' + fromdate + '&Todate=' + toDate + '&datefiltertype=' + filtertype;
        } else {
            url = this.reportUrl + 'InventoryReport/' + apiMethodName + '?reportType=' + reportType + '&channelId=' + channelId + idPart + '&FromDate=' + fromdate + '&Todate=' + toDate;
        }
        return this.http.get<any>(url, { observe: 'response' })
            .toPromise()
            .then(res => ({
                reports: res.body,
                headers: JSON.parse(res.headers.get('X-Pagination'))
            }));
    }

    balanceSheetReport(reportType: string, fromDate, toDate) {
        return this.http.get<any>(`${this.financeURl}FinancialReport/BalanceSheet?reportType=${reportType}&fromDate=${fromDate}&toDate=${toDate}`);
    }

    getAuditReport(reportType: string, moduleId: number, channelId: number, accountId: number, fromDate: any, toDate: any, pageNumber: number, pageSize: number) {
        const url = `${this.reportUrl}AuditReport/AuditReportByModule?reportType=${reportType}&moduleId=${moduleId}&channelId=${channelId}&accountId=${accountId}&fromDate=${fromDate}&toDate=${toDate}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
        return this.http.get<any>(url, { observe: 'response' })
            .toPromise()
            .then(res => ({
                reports: res.body,
                headers: JSON.parse(res.headers.get('X-Pagination'))
            }));
    }

    getAllReportMenus() {
        return this.http.get<any>(`${environment.appOrgUrl}Report`);
    }

    addtoReport(data) {
        return this.http.post<any>(`${environment.appOrgUrl}Report`, data)
            .toPromise()
            .then(res => res);
    }

    getReportDataById(reportId) {
        return this.http.get<any>(`${environment.appOrgUrl}Report/${reportId}`);
    }

    removeSavedSearchReport(savedSearchId: number) {
        return this.http.delete<any>(`${environment.appOrgUrl}Report/SavedSearch?savedSearchId=${savedSearchId}`);
    }

    getWhatsappAvgResponseTime(fromDate: any, toDate: any) {
        return this.http.get<any>(`${this.whatsAppUrl}Dashboard/ResponseAvgTime?StartDateTime=${fromDate}&EndDateTime=${toDate}`);
    }

    getWhatsappConvAvgResponseTime(fromDate: any, toDate: any) {
        return this.http.get<any>(`${this.whatsAppUrl}Dashboard/ConvResponseAvgTime?StartDateTime=${fromDate}&EndDateTime=${toDate}`);
    }

    getWhatsappResponseCount(fromDate: any, toDate: any) {
        return this.http.get<any>(`${this.whatsAppUrl}Dashboard/ResponseCount?StartDateTime=${fromDate}&EndDateTime=${toDate}`);
    }

    getWhatsappQueryCount(fromDate: any, toDate: any) {
        return this.http.get<any>(`${this.whatsAppUrl}Dashboard/Contact?StartDateTime=${fromDate}&EndDateTime=${toDate}`);
    }

    getActivitySummaryCount(data: any) {
        return this.http.post<any>(`${environment.activity}/LionO360/2.0/API/ActivityReport`, data);
    }

    getActivitySummaryReport(data: any) {
        return this.http.post<any>(`${environment.activity}/LionO360/2.0/API/ActivityReport/ActivityListAsync`, data);
    }

    getActivitySummaryReportGroupList(data: any) {
        return this.http.post<any>(`${environment.activity}/LionO360/2.0/API/ActivityReport/GroupActivityListAsync`, data);
    }

    getAccountsReportGroupList(requestModel: FinanceFilterNS.GetAccountsReportGroupByRequestModel) {
        return this.httpService.create(`${environment.reportUrl}InventoryReport/${requestModel?.apiMethodName}`, requestModel);
    }
}
